<template>
  <div>
    <v-col cols="12">
      <v-data-table :headers="headersData" :items="todosParos" :loading="loadingParos">
        <template v-slot:top>
          <div class="d-flex justify-center aling-center">
            <datePicker v-model="params.inicio" format="YYYY-MM-DD" :maxDate="params.fin" label="Desde" clearable
              maxToday class="mx-1" />
            <datePicker v-model="params.fin" format="YYYY-MM-DD" :maxDate="params.fin" label="Hasta)" clearable maxToday
              class="mx-3" />
            <v-autocomplete v-model="params.idMaquinaInstancia" label="Máquina (Opcional)" :items="maquinaInstancias"
              :item-text="nombreMaquina" item-value="idMaquinaIns" class="mx-2" :disabled="loadingParos"
              :loading="loadingParos" clearable />
            <!-- <v-checkbox v-model="params.atravezados" label="Incluir paros que atraviezan" class="mx-1" /> -->
            <v-btn color="primary" @click="getTodosParos()" :loading="loadingParos">Buscar</v-btn>
          </div>
        </template>

        <template v-slot:item.inicio="{ item }">
          <div class="text-center">
            <div>{{ formatFecha(item.inicio) }}</div>
            <div class="caption">{{ formatHora(item.inicio) }}</div>
          </div>
        </template>

        <template v-slot:item.fin="{ item }">
          <div class="text-center">
            <div>{{ formatFecha(item.fin) }}</div>
            <div class="caption">
              {{ item.fin ? formatHora(item.fin) : '-' }}
            </div>
          </div>
        </template>

        <template v-slot:item.duracionSeg="{ item }">
          <div class="text-center">
            {{ formatDuracion(item.duracionSeg) }}
          </div>
        </template>

        <template v-slot:item.acciones="{ item }">
          <div class="text-center">
            <v-tooltip top color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mx-1" v-bind="attrs" v-on="on" @click.stop="abrirDialogEditar(item)">
                  mdi-pen
                </v-icon>
              </template>
              <span class="white--text">Editar paro</span>
            </v-tooltip>

            <v-tooltip top color="black" v-if="item.fin != null">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mx-1" v-bind="attrs" v-on="on" @click.stop="abrirDivisionParosComponente(item)">
                  mdi-scissors-cutting
                </v-icon>
              </template>
              <span class="white--text">Recortar paro</span>
            </v-tooltip>

            <v-tooltip top color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mx-1" v-bind="attrs" v-on="on" @click.stop="abrirDialogDesactivarParos(item)">
                  mdi-trash-can
                </v-icon>
              </template>
              <span class="white--text">Eliminar paro</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialogEditarParo" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          Editar paro
        </v-card-title>

        <v-card-text>
          <v-form ref="formEditarParo">
            <v-row>
              <v-col cols="6">
                <VueCtkDateTimePicker v-model="paroEdit.inicio" label="Inicio" format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" />
              </v-col>

              <v-col cols="6">
                <VueCtkDateTimePicker v-model="paroEdit.fin" label="Fin" format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" />
              </v-col>

              <v-col cols="6">
                <v-autocomplete v-model="paroEdit.idParoTipo" :items="tipoParos" item-text="nombre"
                  item-value="idParoTipo" label="Causa" dense clearable />
              </v-col>

              <v-col cols="6" v-if="subParosTiposFiltrados.length > 0">
                <v-autocomplete v-model="paroEdit.idSubParoTipo" :items="subParosTiposFiltrados"
                  item-text="nombreSubParoTipo" item-value="idSubParoTipo" label="Subcausa" dense clearable />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="cerrarDialogEditar()" :loading="loadingParoEditar">Cancelar</v-btn>
          <v-btn text color="error" @click="guardarCambiosParo()" :disabled="!puedeGuardarParo"
            :loading="loadingParoEditar">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRecortarParo" persistent>
      <v-card>
        <v-card-title class="headline">
          Recortar paro
        </v-card-title>

        <v-card-text>
          <div class="mb-3">
            <div>
              Duración original:
              <strong>{{ duracionOriginalTexto }}</strong>
            </div>
            <div>
              Inicio original:
              <strong>{{ formatFecha(paroRecorteMeta.inicioOriginal) }}</strong>
              <span class="caption ml-1">
                {{ formatHora(paroRecorteMeta.inicioOriginal) }}
              </span>
            </div>

            <div>
              Fin original:
              <strong>{{ formatFecha(paroRecorteMeta.finOriginal) }}</strong>
              <span class="caption ml-1">
                {{ formatHora(paroRecorteMeta.finOriginal) }}
              </span>
            </div>
            <div :class="{ 'red--text': minutosSinAsignar !== 0, 'green--text': minutosSinAsignar === 0 }">
              Minutos sin asignar: <strong>{{ minutosSinAsignar }}</strong>
            </div>
          </div>


          <v-btn small color="primary" text class="mb-2" @click="agregarSegmento()">
            Agregar segmento
          </v-btn>

          <v-simple-table>
            <thead>
              <tr>
                <th class="text-center">#</th>
                <th class="text-center">Inicio</th>
                <th class="text-center">Fin</th>
                <th class="text-center">Causa</th>
                <th class="text-center">Subcausa</th>
                <th class="text-center">Activo</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(segmento, index) in recortesParo" :key="index">
                <td class="text-center">
                  {{ index + 1 }}
                </td>

                <td class="text-center">
                  <VueCtkDateTimePicker v-model="segmento.inicio" label="Inicio" format="YYYY-MM-DD HH:mm"
                    formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora"
                    :min-date="inicioOriginalPicker" :max-date="finOriginalPicker" />
                </td>

                <td class="text-center">
                  <VueCtkDateTimePicker v-model="segmento.fin" label="Fin" format="YYYY-MM-DD HH:mm"
                    formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora"
                    :min-date="inicioOriginalPicker" :max-date="finOriginalPicker" />
                </td>

                <td class="text-center">
                  <v-autocomplete v-model="segmento.idParoTipo" :items="tipoParos" item-text="nombre"
                    item-value="idParoTipo" dense hide-details clearable class="ma-0 pa-0" label="Tipo" />
                </td>

                <td class="text-center">
                  <v-autocomplete v-model="segmento.idSubParoTipo" :items="subParosTiposFiltrados2(segmento)"
                    item-text="nombreSubParoTipo" item-value="idSubParoTipo" dense hide-details clearable
                    class="ma-0 pa-0" label="Subtipo" />
                </td>

                <td class="text-center">
                  <v-switch v-model="segmento.activo" inset hide-details class="ma-0 pa-0"></v-switch>
                </td>

                <td class="text-center">
                  <v-icon small class="mx-1" @click="eliminarSegmento(index)">
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="cerrarDialogRecortar()" :loading="loadingParoRecortar">Cancelar</v-btn>
          <v-btn color="error" text @click="guardarRecortesParo()" :disabled="!puedeGuardarRecorte"
            :loading="loadingParoRecortar">
            Guardar recortes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDesactivarParos" max-width="480" persistent>
      <v-card>
        <v-card-title class="headline">
          Desactivar paros
        </v-card-title>

        <v-card-text>
          <!-- <p class="mb-2">
            Se desactivarán
            <strong>{{ parosADesactivar.length }}</strong>
            paro(s) asociado(s) a este registro.
          </p> -->
          <p>
            Esta acción eliminará los paros.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cerrarDialogDesactivarParos">
            Cancelar
          </v-btn>
          <v-btn text color="red" dark :loading="loadingDesactivarParos" @click="confirmarDesactivarParos">
            Desactivar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DivisionParosComponente v-if="dialogDivisionParosComponente" v-model="dialogDivisionParosComponente"
      :paro="paroSeleccionado" :paros-tipos="tipoParos" :sub-paros-tipos="tipoSubparos"
      @close="cerrarDivisionParosComponente" @guardar-segmentos="onGuardarSegmentos" :loading="loadingParoRecortar"/>
  </div>
</template>

<script>
import axios from 'axios';
import DivisionParosComponente from './DivisionParosComponente.vue';

export default {
  components: {
    DivisionParosComponente,
  },
  data() {
    return {
      params: {
        inicio: null,
        fin: null,
        atravezados: false,
        idMaquinaInstancia: null,
      },

      maquinaInstancias: [],
      tipoParos: [],
      tipoSubparos: [],

      headersData: [
        { text: 'Tipo de paro', value: 'paroTipo', align: 'center', sortable: false },
        { text: 'Subtipo de paro', value: 'subParoTipo', align: 'center', sortable: false },
        { text: 'Máquina', value: 'maquina', align: 'center', sortable: false },
        { text: 'Inicio', value: 'inicio', align: 'center', sortable: true },
        { text: 'Fin', value: 'fin', align: 'center', sortable: true },
        { text: 'Duración (seg)', value: 'duracionSeg', align: 'center', sortable: true },
        { text: 'Acciones', value: 'acciones', align: 'center', sortable: true },
      ],

      todosParos: [],

      paroSeleccionado: null,
      recortesParo: [],
      parosADesactivar: [],
      segmentosParoActual: [],

      paroEdit: {
        idParo: null,
        inicio: null,
        fin: null,
        idParoTipo: null,
        idSubParoTipo: null,
      },
      paroRecorteMeta: {
        idParo: null,
        inicioOriginal: null,
        finOriginal: null,
        totalMinutos: 0,
      },

      dialogEditarParo: false,
      dialogRecortarParo: false,
      dialogDesactivarParos: false,
      dialogDivisionParosComponente: false,

      loadingParos: false,
      loadingParoEditar: false,
      loadingParoRecortar: false,
      loadingParoEliminar: false,
      loadingDesactivarParos: false,
    }
  },
  methods: {
    nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,

    initialize() {
      this.getMaquinaInstancias();
      this.getTipoParos();
      this.getTipoSubParos();
    },
    getMaquinaInstancias() {
      axios
        .get("/MaquinaInstancias")
        .then(response => this.maquinaInstancias = response.data)
        .catch(error => console.log(error))
    },
    getTipoParos() {
      axios
        .get("/ParoTipos")
        .then((response) => {
          this.tipoParos = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTipoSubParos() {
      axios
        .get("/SubParoTipos")
        .then((response) => {
          this.tipoSubparos = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTodosParos() {
      this.loadingParos = true;
      let params = {};

      if (this.params.inicio) params.inicio = this.params.inicio;
      if (this.params.fin) params.fin = this.params.fin;
      if (this.params.atravezados) params.atravezados = this.params.atravezados;

      if (this.params.idMaquinaInstancia != null && this.params.idMaquinaInstancia > 0) {
        params.IdMaquinaIns = this.params.idMaquinaInstancia;
      }

      axios
        .get("/Paros/ListarTodosParos", { params })
        .then((response) => {
          this.todosParos = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener los paros:", error);
        })
        .finally(() => {
          this.loadingParos = false;
        })
    },

    abrirDialogEditar(item) {
      this.paroSeleccionado = item;

      this.paroEdit = {
        idParo: item.idParo,
        activo: item.condicion !== false,
        inicio: item.inicio ? item.inicio.replace(' ', 'T') : null,
        fin: item.fin ? item.fin.replace(' ', 'T') : null,
        idParoTipo: item.idParoTipo,
        idSubParoTipo: item.idSubParoTipo,
      };

      this.dialogEditarParo = true;
    },

    cerrarDialogEditar() {
      this.dialogEditarParo = false;
      this.paroSeleccionado = null;
    },

    guardarCambiosParo() {
      if (!this.puedeGuardarParo) return

      const idsReducidos =
        this.paroSeleccionado && Array.isArray(this.paroSeleccionado.idsParos)
          ? this.paroSeleccionado.idsParos
          : (this.paroEdit.idParo ? [this.paroEdit.idParo] : [])

      const toIso = (value) => {
        if (!value) return null
        const d = new Date(String(value).replace(' ', 'T'))
        return isNaN(d.getTime()) ? null : d.toISOString()
      }

      const payload = {
        idsReducidos: idsReducidos,
        idParoTipo: this.paroEdit.idParoTipo,
        inicio: toIso(this.paroEdit.inicio),
        fin: toIso(this.paroEdit.fin),
        condicion: this.paroEdit.activo,
      }

      // 👉 solo agregamos idSubParoTipo si realmente tiene valor
      if (this.paroEdit.idSubParoTipo != null && this.paroEdit.idSubParoTipo !== '') {
        payload.idSubParoTipo = this.paroEdit.idSubParoTipo
      }

      this.loadingParoEditar = true

      axios
        .put('/Paros/ActualizarTodosParos', payload)
        .then(() => {
          this.dialogEditarParo = false
          this.getTodosParos()
        })
        .catch((error) => {
          console.error('Error al actualizar el paro:', error)
        })
        .finally(() => {
          this.loadingParoEditar = false
        })
    },

    abrirDialogRecortar(item) {
      this.paroSeleccionado = item

      this.paroRecorteMeta = {
        idParo: item.idParo,
        inicioOriginal: item.inicio,
        finOriginal: item.fin,
        duracionSeg: item.duracionSeg || 0,
      }

      const inicioPicker = this.formatDateTimePicker(item.inicio)
      const finPicker = this.formatDateTimePicker(item.fin)

      this.recortesParo = [
        {
          inicio: inicioPicker,
          fin: finPicker,
          idParoTipo: item.idParoTipo || null,
          idSubParoTipo: item.idSubParoTipo || null,
          activo: true,
        },
      ]

      this.dialogRecortarParo = true
    },

    cerrarDialogRecortar() {
      this.dialogRecortarParo = false
      this.paroSeleccionado = null
      this.recortesParo = []
    },

    agregarSegmento() {
      this.recortesParo.push({
        minutos: 0,
        idParoTipo: null,
        idSubParoTipo: null,
        activo: true,
      })
    },

    eliminarSegmento(index) {
      this.recortesParo.splice(index, 1)
    },

    guardarRecortesParo() {
      if (!this.puedeGuardarRecorte) return

      this.loadingParoRecortar = true;
      const payload = {
        idsReducidos: this.paroSeleccionado.idsParos, // 👈 los que vienen del row
        segmentos: this.recortesParo.map(seg => ({
          inicio: new Date(seg.inicio.replace(' ', 'T')).toISOString(),
          fin: new Date(seg.fin.replace(' ', 'T')).toISOString(),
          idParoTipo: seg.idParoTipo,
          idSubParoTipo: seg.idSubParoTipo ?? null,
          condicion: seg.activo,
        })),
      }

      axios.post('/Paros/RecortarTodosParos', payload)
        .then(() => {
          this.dialogRecortarParo = false;
          this.getTodosParos()
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.loadingParoRecortar = false;
        })
    },
    abrirDialogDesactivarParos(item) {
      // si viene agrupado: idsParos; si no, un solo id
      this.parosADesactivar = Array.isArray(item.idsParos)
        ? item.idsParos
        : (item.idParo ? [item.idParo] : [])

      this.dialogDesactivarParos = true
    },

    cerrarDialogDesactivarParos() {
      this.dialogDesactivarParos = false
      this.parosADesactivar = []
    },

    confirmarDesactivarParos() {
      if (!this.parosADesactivar.length) return

      this.loadingDesactivarParos = true

      axios
        .put('/Paros/DesactivarTodosParos', {
          idsParos: this.parosADesactivar,
        })
        .then(() => {
          this.dialogDesactivarParos = false
          this.getTodosParos() // recarga la tabla
        })
        .catch(err => {
          console.error('Error al desactivar paros:', err)
        })
        .finally(() => {
          this.loadingDesactivarParos = false
        })
    },

    abrirDivisionParosComponente(item) {
      this.dialogDivisionParosComponente = true;
      this.paroSeleccionado = item;
    },
    cerrarDivisionParosComponente() {
      this.dialogDivisionParosComponente = false;
      this.segmentosParoActual = [];
      this.paroSeleccionado = null;
    },

    onGuardarSegmentos(segmentos) {
      // if (!this.puedeGuardarRecorte) return;

      this.loadingParoRecortar = true;

      const idsReducidos =
        (segmentos[0] && segmentos[0].idsParos) ||
        (this.paroSeleccionado && this.paroSeleccionado.idsParos) ||
        [];

      const payload = {
        idsReducidos,
        // segmentos: segmentos.map(seg => ({
        //   inicio: new Date(seg.inicio.replace(' ', 'T')).toISOString(),
        //   fin: new Date(seg.fin.replace(' ', 'T')).toISOString(),
        //   idParoTipo: seg.idParoTipo,
        //   idSubParoTipo: seg.idSubParoTipo ?? null,
        //   condicion: true,
        // })),
        segmentos: segmentos.map(seg => ({
          inicio: (seg.inicio || '').replace(' ', 'T'), // "2025-12-01T16:38:23"
          fin: (seg.fin || '').replace(' ', 'T'),       // "2025-12-01T17:00:00"
          idParoTipo: seg.idParoTipo,
          idSubParoTipo: seg.idSubParoTipo ?? null,
          condicion: true,
        })),
      };

      axios.post('/Paros/RecortarTodosParos', payload)
        .then(() => {
          this.dialogRecortarParo = false;
          this.getTodosParos();
          this.cerrarDivisionParosComponente();
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.loadingParoRecortar = false;
        });
    },



    parseDate(value) {
      if (!value) return null
      if (value instanceof Date) return value

      const normalized = String(value)
        .replace(/\//g, '-')
        .replace(' ', 'T')

      const d = new Date(normalized)
      return isNaN(d.getTime()) ? null : d
    },
    formatHoraHM(value) {
      const d = this.parseDate(value)
      if (!d) return null
      const h = String(d.getHours()).padStart(2, '0')
      const m = String(d.getMinutes()).padStart(2, '0')
      return `${h}:${m}`
    },

    hhmmToMinutes(hhmm) {
      if (!hhmm) return null
      const [h, m] = hhmm.split(':').map(x => parseInt(x, 10))
      if (isNaN(h) || isNaN(m)) return null
      return h * 60 + m
    },
    formatFecha(value) {
      const d = this.parseDate(value)
      if (!d) return '-'
      return d.toLocaleDateString('es-MX')
    },
    formatHora(value) {
      const d = this.parseDate(value)
      if (!d) return '-'
      return d.toLocaleTimeString('es-MX', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
    formatDuracion(segundos) {
      if (segundos == null || isNaN(segundos)) return '-'

      const total = Math.floor(segundos)
      const dias = Math.floor(total / 86400)
      const horas = Math.floor((total % 86400) / 3600)
      const minutos = Math.floor((total % 3600) / 60)
      const seg = total % 60

      const partes = []
      if (dias) partes.push(`${dias}d`)
      if (horas) partes.push(`${horas}h`)
      if (minutos) partes.push(`${minutos}m`)
      if (seg || partes.length === 0) partes.push(`${seg}s`)

      return partes.join(' ')
    },
    formatDateTimePicker(value) {
      const d = this.parseDate(value)
      if (!d) return null

      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')

      return `${y}-${m}-${day} ${hh}:${mm}`   // mismo formato que usas en el picker
    },

    agregarSegmento() {
      // inicio y fin del paro original en formato para el picker
      const inicioOriginal = this.formatDateTimePicker(this.paroRecorteMeta.inicioOriginal)
      const finOriginal = this.formatDateTimePicker(this.paroRecorteMeta.finOriginal)

      // si ya hay segmentos, el nuevo inicia donde termina el último
      const ultimo = this.recortesParo[this.recortesParo.length - 1]

      const inicioBase = ultimo && ultimo.fin
        ? ultimo.fin
        : inicioOriginal

      const finBase = finOriginal

      this.recortesParo.push({
        inicio: inicioBase,   // siempre dentro del rango original
        fin: finBase,         // siempre dentro del rango original
        idParoTipo: null,
        idSubParoTipo: null,
        activo: true,
      })
    },
    parsePickerDateTime(value) {
      if (!value) return null
      const d = new Date(String(value).replace(' ', 'T'))
      return isNaN(d.getTime()) ? null : d
    },
    _intervalosRecorte() {
      const result = []

      for (const seg of this.recortesParo) {
        const ini = this.parsePickerDateTime(seg.inicio)
        const fin = this.parsePickerDateTime(seg.fin)
        if (!ini || !fin) continue

        const start = Math.floor(ini.getTime() / 60000)
        const end = Math.floor(fin.getTime() / 60000)

        result.push({ start, end })
      }

      return result
    },
    subParosTiposFiltrados2(segmento) {
      if (!segmento || segmento.idParoTipo == null) return []

      if (
        segmento.idSubParoTipo &&
        !this.tipoSubparos.some(
          tp => tp.idParoTipo === segmento.idParoTipo && tp.idSubParoTipo === segmento.idSubParoTipo
        )
      ) {
        segmento.idSubParoTipo = null
      }

      return this.tipoSubparos.filter(tp => tp.idParoTipo === segmento.idParoTipo)
    },
  },
  computed: {
    subParosTiposFiltrados() {
      if (this.paroEdit.idParoTipo == null) return []
      return this.tipoSubparos.filter(tp => tp.idParoTipo === this.paroEdit.idParoTipo)
    },

    puedeGuardarParo() {
      if (!this.paroEdit.idParoTipo) return false;

      if (!this.paroEdit.inicio || !this.paroEdit.fin) return false;

      const inicio = new Date(this.paroEdit.inicio);
      const fin = new Date(this.paroEdit.fin);

      if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return false;

      if (inicio.getTime() >= fin.getTime()) return false;

      return true;
    },
    puedeGuardarRecorte() {
      const iniOrig = this.parseDate(this.paroRecorteMeta.inicioOriginal)
      const finOrig = this.parseDate(this.paroRecorteMeta.finOriginal)
      if (!iniOrig || !finOrig) return false

      const startOrigMin = iniOrig.getHours() * 60 + iniOrig.getMinutes()
      const endOrigMin = finOrig.getHours() * 60 + finOrig.getMinutes()

      const intervals = this.intervalosRecorte
      if (!intervals.length) return false

      // 1) Cada segmento válido, con tipo y dentro del rango
      for (const i of intervals) {
        const seg = i.seg

        if (!seg.idParoTipo) return false          // tipo obligatorio
        if (!seg.inicio || !seg.fin) return false // fechas completas
        if (i.end <= i.start) return false        // fin > inicio

        if (i.start < startOrigMin) return false  // antes del paro original
        if (i.end > endOrigMin) return false  // después del paro original
      }

      // 2) Sin solapes
      const ordenados = [...intervals].sort((a, b) => a.start - b.start)
      for (let k = 1; k < ordenados.length; k++) {
        if (ordenados[k].start < ordenados[k - 1].end) {
          return false
        }
      }

      // 3) La suma de minutos debe ser EXACTAMENTE igual a la duración original
      if (this.totalMinAsignado !== this.totalMinOriginal) return false

      return true
    },


    totalMinOriginal() {
      const ini = this.parseDate(this.paroRecorteMeta.inicioOriginal)
      const fin = this.parseDate(this.paroRecorteMeta.finOriginal)
      if (!ini || !fin) return 0

      const startMin = ini.getHours() * 60 + ini.getMinutes()
      const endMin = fin.getHours() * 60 + fin.getMinutes()

      // ej: 14:36:34 → 876; 14:59:55 → 899; 899-876 = 23 min
      return endMin - startMin
    },
    intervalosRecorte() {
      return this.recortesParo
        .map(seg => {
          const ini = this.parsePickerDateTime(seg.inicio)
          const fin = this.parsePickerDateTime(seg.fin)
          if (!ini || !fin) return null

          const start = ini.getHours() * 60 + ini.getMinutes()
          const end = fin.getHours() * 60 + fin.getMinutes()

          return {
            start,
            end,
            seg, // referencia al segmento original
          }
        })
        .filter(Boolean)
    },
    segmentosNormalizados() {
      const iniOriginal = this.parseDate(this.paroRecorteMeta.inicioOriginal)
      const finOriginal = this.parseDate(this.paroRecorteMeta.finOriginal)
      if (!iniOriginal || !finOriginal) return []

      return this.recortesParo.map((seg, idx) => {
        const inicio = this.parsePickerDateTime(seg.inicio)
        const fin = this.parsePickerDateTime(seg.fin)

        return {
          index: idx,
          inicio,
          fin,
          idParoTipo: seg.idParoTipo,
          idSubParoTipo: seg.idSubParoTipo,
          activo: seg.activo,
        }
      })
    },

    totalMinAsignado() {
      return this.intervalosRecorte.reduce((sum, i) => {
        if (i.end <= i.start) return sum
        return sum + (i.end - i.start)
      }, 0)
    },


    minutosSinAsignar() {
      return this.totalMinOriginal - this.totalMinAsignado
    },
    duracionOriginalTexto() {
      const segs = this.paroRecorteMeta?.duracionSeg || 0
      return this.formatDuracion(segs) // d h m s
    },

    // Formato que espera el VueCtkDateTimePicker (YYYY-MM-DD HH:mm)
    inicioOriginalPicker() {
      return this.formatDateTimePicker(this.paroRecorteMeta.inicioOriginal)
    },

    finOriginalPicker() {
      return this.formatDateTimePicker(this.paroRecorteMeta.finOriginal)
    },
  },
  watch: {
    'paroEdit.idParoTipo'(nv) {
      // Si no hay tipo, sub-tipo debe quedar null
      if (nv == null) {
        this.paroEdit.idSubParoTipo = null
        return
      }

      // Si aún no cargan los subtipos, no borres nada
      if (!this.tipoSubparos || !this.tipoSubparos.length) return

      // Si el subTipo actual no pertenece al nuevo tipo, límpialo
      const ok = this.tipoSubparos.some(tp =>
        tp.idParoTipo === nv && tp.idSubParoTipo === this.paroEdit.idSubParoTipo
      )
      if (!ok) this.paroEdit.idSubParoTipo = null
    },
  },
  mounted() {
    this.initialize();
  }
}
</script>